import urlJoin from "url-join";
import { httpGetSimple } from "./makeRequest.js";
/**
 * Asks the server for a list of known ticket types.
 */
export async function requestKnownTicketTypes(zupassServerUrl) {
    return httpGetSimple(urlJoin(zupassServerUrl, `/issue/known-ticket-types`), async (resText) => JSON.parse(resText));
}
